import React, { useCallback, useEffect, useState } from "react";
import { Card, Select } from "../../../common";
import { useDispatch, useSelector } from "react-redux";
import { useGetActiveEnterpriseQuery, useGetEnterpriseSolutionStatsMutation, useGetTrackCompanyListQuery } from "../../../../store/Company/companyApiSlice";
import { EnterpriseCard } from "./EnterpriseCard";
import { CommonToast } from "../../../common/Toast";
import EnterpriseRequestTable from "../dashboard/EnterpriseRequestTable";
import SearchBar from "../../../common/SearchBar";
import { debounce } from "../../../../utils/Helper";
import { setEnterprise } from "../../../../store/enterprise/enterpriseSlice";
import { ReactComponent as CompanyInfo } from "../../../../assets/images/signUp/companyInfo.svg";
import { useMemo } from "react";
import StatsOverview from "../StatsOverview";
import AddCompaniesSection from "../AddCompaniesSection";
import ContactSupportCard from "../../../common/ContactSupportCard";
export const EnterpriseCompanies = () => {
  const { token } = useSelector((state) => state.auth);
  const dispatch = useDispatch()
  const [page, setPage] = useState(1);
  const [limit, setLimit] = useState(9);
  const { selectedEnterprise: stateEnterprise } = useSelector((state) => state.enterprise);
  const [enterpriseData, setEnterpriseData] = useState();
  const [enterpriseTrackedData, setEnterpriseTrackedData] = useState();
  const [searchTerm, setSearchTerm] = useState('');
  const [selectedEnterprise, setSelectedEnterprise] = useState();
  const [enterpriseStats, setEnterpriseStats] = useState(null)
  const { data, error, refetch } = useGetActiveEnterpriseQuery({
    token,
  });
  const [getEnterpriseSolutionStats] = useGetEnterpriseSolutionStatsMutation();

  useEffect(() => {
    setSelectedEnterprise(stateEnterprise)
  }, [stateEnterprise])

  const { data: trackedCompany, refetch: refetchTrack, isUninitialized } = useGetTrackCompanyListQuery({
    token,
    id: selectedEnterprise?.id,
    page,
    limit,
    searchTerm
  }, {skip: !selectedEnterprise?.id});

  const fetchStats = async () => {
    const res = await getEnterpriseSolutionStats({
      token,
      id: selectedEnterprise?.id
    });
    setEnterpriseStats(res.data);
  }
  useEffect(() => {
    if (selectedEnterprise) {
      fetchStats();
    }
  }, [selectedEnterprise])

  useEffect(() => {
    if (data && !enterpriseData) {
      setEnterpriseData(data);
    } else if (error) {
      CommonToast.error(error.message || "Something went wrong");
    }
  }, [data]);

  useEffect(() => {
    if (!selectedEnterprise) {
      dispatch(setEnterprise(enterpriseData?.results[0]));
    }
    if(!isUninitialized){
      refetchTrack();
    }
  }, [enterpriseData, isUninitialized])

  useEffect(() => {
    setEnterpriseTrackedData(trackedCompany);
  }, [trackedCompany])

  const handleChange = (value) => {
    setSearchTerm(value);
  };

  const optimizedFn = useCallback(debounce(handleChange), []);

  const checkCredit = (data) => {
    return data?.enterprise_type === "PARTNER_PROGRAM" ? "Unlimited Credits" : data?.credits && data?.credits > 1 ? data?.credits + " Credits" : data?.credits === 1 ? data?.credits + " Credit" : "0 Credit";
  }

  return (
    <Card classes="w-full md:col-start-1 md:col-end-10 ">
      <div className="flex justify-between mb-4">
        <div>
          <h3 className="text-left text-f24 text-primary font-bold">
            My Enterprise
          </h3>
          <p className="text-left text-f16 text-secondarytwo mb-4">
            Manage all your enterprises from a single platform.
          </p>
        </div>
        {enterpriseData?.results?.length > 0 && <div>
          <Select
            label={selectedEnterprise?.enterprise_type === "PARTNER_PROGRAM" ? "Your Enterprise" : `Your Enterprise (${checkCredit(selectedEnterprise)})`}
            id="countryCode"
            value={selectedEnterprise}
            onChange={(e) => dispatch(setEnterprise(e.target.value))}
            classes="w-[300px] text-left"
            icon={true}
          >
            {enterpriseData?.results?.map((enterprise) => (
              <option key={enterprise.id} value={enterprise}>
                {enterprise.name}
              </option>
            ))}
          </Select>
        </div>}
      </div>
      {!(enterpriseData?.results?.length > 0) ? <div className="w-full bg-white p-4 rounded-[12px] mb-4 flex justify-center items-center"><div className=" max-w-[820px] flex flex-col gap-4 justify-center items-center">
        <p className="text-[24px] font-bold text-primary">Track your buyers with TREVEX</p>
        <CompanyInfo className="w-[336px] h-[260px]" />
        <p className="font-bold text-gray-500">Effortlessly upload your customer lists, and Trevex handles profile creation, verification, and credibility boosting. Enjoy real-time monitoring, instant updates, and effective risk management for smarter decisions.</p>
        <p className="font-bold text-gray-500">For more information, contact us at <a href="mailto:info@trevex.io" className="underline text-link">info@trevex.io</a></p>
      </div></div> :
        <><div className="flex justify-between items-center bg-white p-4 rounded-[12px] mb-4">
          <div className="flex gap-2 items-center justify-start flex-wrap">
            <p className="text-left text-f20 text-primary font-bold">Tracking Companies</p>
            <div className="text-link bg-lightError rounded-full px-3 py-1">
              {`${enterpriseTrackedData?.total_results ?? 0} COMPANIES`}
            </div>
          </div>
          <SearchBar onSearch={optimizedFn} mbZero={true} pbZero={true} />
        </div>
          {selectedEnterprise?.enterprise_type === "PARTNER_PROGRAM" && <StatsOverview enterpriseStats={enterpriseStats} />}
          {enterpriseTrackedData?.results?.length > 0 ? <EnterpriseRequestTable enterpriseData={enterpriseTrackedData}
            page={page}
            setPage={setPage} selectedEnterprise={selectedEnterprise} /> : <div><AddCompaniesSection enterprise={selectedEnterprise} /><ContactSupportCard /></div>}
        </>
      }
    </Card>
  );
};
